// extracted by mini-css-extract-plugin
export default {"page-title":"index__page-title--WgfeB","section-title":"index__section-title--Shrfa","layout":"index__layout--j6l2q","content":"index__content--GQmjz"};